import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { connectedAccountsStore } from '../store/store';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { toggleEditAccountWindow } from '../actions/editAccount/toggleEditAccountWindow';
import { getSelectedAccount } from '../selectors/getSelectedAccount';
import { getEditAccountSyncRequest } from '../selectors/getEditAccountSyncRequest';
import { setSyncRequest } from '../services/setSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import { resetEditAccountStore } from '../actions/editAccount/resetEditAccountStore';
import { updateEditIsSaving } from '../actions/editAccount/updateEditIsSaving';
import { updateEditOutgoingServer } from '../actions/editAccount/updateEditOutgoingServer';
import { updateEditOutgoingPort } from '../actions/editAccount/updateEditOutgoingPort';
import { updateEditIncomingServer } from '../actions/editAccount/updateEditIncomingServer';
import { updateEditIncomingPort } from '../actions/editAccount/updateEditIncomingPort';
import { updateEditUseAltUsernamePassword } from '../actions/editAccount/updateEditUseAltUsernamePassword';
import { updateEditAltUsername } from '../actions/editAccount/updateEditAltUsername';
import { updateEditAltPassword } from '../actions/editAccount/updateEditAltPassword';
import { updateEditUserName } from '../actions/editAccount/updateEditUserName';
import { updateEditPassword } from '../actions/editAccount/updateEditPassword';
import { updateEditDisplayName } from '../actions/editAccount/updateEditDisplayName';
import { updateEditIncomingAuth } from '../actions/editAccount/updateEditIncomingAuth';
import { updateEditIncomingSecurity } from '../actions/editAccount/updateEditIncomingSecurity';
import strings from 'owa-strings/owa-options-strings';
import { connectGmail } from '../utils/connectGmail';
import IncomingAccountInformation from './IncomingAccountInformation';
import IncomingServerInformation from './IncomingServerInformation';
import OutgoingServerInformation from './OutgoingServerInformation';
import { ConnectionType } from '../store/schema/ConnectionType';
var styles = require('./ConnectedAccountEditor.scss');
var ConnectedAccountEditor = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectedAccountEditor, _super);
    function ConnectedAccountEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClose = function () {
            toggleEditAccountWindow({ editAccountOpen: false });
            var selected = getSelectedAccount();
            if (selected) {
                var syncRequest = selected.syncRequest;
                resetEditAccountStore(syncRequest);
            }
        };
        _this.onSave = function () {
            updateEditIsSaving(true);
            setSyncRequest(getEditAccountSyncRequest()).then(function (response) {
                updateEditIsSaving(false);
                toggleEditAccountWindow({ editAccountOpen: false });
                initConnectedAccountsFull();
            });
        };
        return _this;
    }
    ConnectedAccountEditor.prototype.render = function () {
        var store = connectedAccountsStore();
        return (React.createElement(Dialog, { hidden: !store.dialogWindowState.editAccountOpen, dialogContentProps: {
                type: DialogType.normal,
                title: strings.options_connected_edit_title,
            }, modalProps: {
                isBlocking: true,
                containerClassName: styles.dialog,
                onDismiss: this.onClose,
            } },
            store.editAccountState.isErrorStatus &&
                (store.editAccountState.isOAuthSync ? (React.createElement("div", null,
                    React.createElement(Label, null, strings.options_connected_edit_oauthFailedLabel),
                    React.createElement(Link, { onClick: connectGmail }, strings.options_connected_edit_reconnectOAuthLink))) : (React.createElement(Label, null, strings.options_connected_edit_basicAuthFailedLabel))),
            React.createElement(IncomingAccountInformation, { displayName: store.editAccountState.displayName, emailAddress: store.editAccountState.emailAddress, username: store.editAccountState.username, disableEmailAddress: true, renderUserNameContent: true, renderNewFolderContent: false, isBasicAuth: !store.editAccountState.isOAuthSync, onUpdateDisplayName: updateEditDisplayName, onUpdateUserName: updateEditUserName, onUpdatePassword: updateEditPassword }),
            !store.editAccountState.isSendOnly && (React.createElement(IncomingServerInformation, { isBasicAuth: !store.editAccountState.isOAuthSync, connectionType: store.editAccountState.syncProtocol === 'Pop'
                    ? ConnectionType.PopSmtp
                    : ConnectionType.ImapSmtp, renderRemoteSend: false, incomingServer: store.editAccountState.incomingServer, incomingPort: store.editAccountState.incomingPort, leaveCopy: store.editAccountState.leaveCopy, leaveCopyDisabled: true, basicAuthProps: {
                    connectionType: store.editAccountState.syncProtocol === 'Pop'
                        ? ConnectionType.PopSmtp
                        : ConnectionType.ImapSmtp,
                    incomingAuth: store.editAccountState.incomingAuth,
                    incomingSecurity: store.editAccountState.incomingSecurity,
                    onUpdateIncomingAuth: updateEditIncomingAuth,
                    onUpdateIncomingSecurity: updateEditIncomingSecurity,
                }, onUpdateIncomingServer: updateEditIncomingServer, onUpdateIncomingPort: updateEditIncomingPort })),
            React.createElement(OutgoingServerInformation, { isBasicAuth: !store.editAccountState.isOAuthSync, outgoingServer: store.editAccountState.outgoingServer, outgoingPort: store.editAccountState.outgoingPort, onUpdateOutgoingServer: updateEditOutgoingServer, onUpdateOutgoingPort: updateEditOutgoingPort, isRemoteSend: function () { return !!store.editAccountState.outgoingServer; }, isSendOnly: function () { return store.editAccountState.isSendOnly; }, smtpAccountInformationProps: {
                    useAltUserNamePassword: function () { return store.editAccountState.useAltUsernamePassword; },
                    onUpdateUseAltUserNamePassword: updateEditUseAltUsernamePassword,
                    onUpdateSmtpUserName: updateEditAltUsername,
                    onUpdateSmtpPassword: updateEditAltPassword,
                } }),
            React.createElement(DialogFooter, null,
                store.editAccountState.isSaving && (React.createElement(Spinner, { size: SpinnerSize.large, className: styles.spinner })),
                React.createElement(PrimaryButton, { onClick: this.onSave, disabled: store.editAccountState.isSaving }, strings.options_connected_saveButton),
                React.createElement(DefaultButton, { onClick: this.onClose, disabled: store.editAccountState.isSaving }, strings.options_connected_discardButton))));
    };
    ConnectedAccountEditor = tslib_1.__decorate([
        observer
    ], ConnectedAccountEditor);
    return ConnectedAccountEditor;
}(React.Component));
export default ConnectedAccountEditor;
//# sourceMappingURL=ConnectedAccountEditor.js.map